import { Spinner } from "./spinner";
import { cn } from "../../lib/utils";

type PageLoadingContainerProps = {
  className?: string;
  fullScreen?: boolean;
};

export function PageLoadingContainer({
  className,
  fullScreen = true,
}: PageLoadingContainerProps) {
  return (
    <div
      className={cn(
        "flex w-full items-center justify-center px-4 py-8",
        fullScreen && "bg-background",
        fullScreen ? "min-h-[var(--app-height)]" : "min-h-[50vh]",
        className,
      )}
    >
      <Spinner className='text-primary size-8' label='Loading' />
    </div>
  );
}
